import { Banner, Card, CardText, LinkButton, Loader, Row, StatusTable, SubmitBar } from "@egovernments/digit-ui-react-components";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {convertToNocObject, stringReplaceAll, convertForm11ToBPAObject} from "../../../utils";

const GetActionMessage = (props) => {
  const bpaData = props.data?.PermissionOfSubdivision?.[0];
  const bpaBusinessService = props.data?.PermissionOfSubdivision?.[0]?.businessService || "BPA_FORM11";
  let bpaStatus = bpaData?.status;
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;

  if (props.isSuccess) {
    if (getAppAction == "BPA_SUBMIT_APP") return !window.location.href.includes("editApplication") ? props?.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData?.workflow?.action}_${stringReplaceAll(bpaStatus," ","_").toUpperCase()}`) : props?.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData?.workflow?.action}_${stringReplaceAll(bpaStatus," ","_").toUpperCase()}`);
    return !window.location.href.includes("editApplication") ? props?.t(`BPA_HEADER_${bpaBusinessService}_${bpaData?.workflow?.action}_${stringReplaceAll(bpaStatus," ","_").toUpperCase()}`) : props?.t(`BPA_HEADER_${bpaBusinessService}_${bpaData?.workflow?.action}_${stringReplaceAll(bpaStatus," ","_").toUpperCase()}`);
  } else if (props.isLoading) {
    return !window.location.href.includes("editApplication") ? props?.t("CS_BPA_APPLICATION_PENDING") : props?.t("CS_BPA_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("editApplication") ? props?.t("CS_BPA_APPLICATION_FAILED") : props?.t("CS_BPA_APPLICATION_FAILED");
  }
};

const getCardText = (t, props) => {
  const bpaData = props?.PermissionOfSubdivision?.[0];
  const bpaBusinessService = props.data?.PermissionOfSubdivision?.[0]?.businessService || "BPA_FORM11";
  let bpaStatus = bpaData?.status;
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (getAppAction == "BPA_SUBMIT_APP") return t(`BPA_SUBMIT_SUB_HEADER_${bpaBusinessService}_${bpaData?.workflow?.action}_${bpaData?.additionalDetails?.typeOfArchitect ? bpaData?.additionalDetails?.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus," ","_").toUpperCase()}`)
  return t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaData?.workflow?.action}_${bpaData?.additionalDetails?.typeOfArchitect ? bpaData?.additionalDetails?.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus," ","_").toUpperCase()}`)
}

const rowContainerStyle = {
  padding: "4px 0px",
  justifyContent: "space-between",
};

const getApplicationNoLabel = (props) => {
  let bpaBusinessService = props?.BPA?.[0]?.businessService ? props?.BPA?.[0]?.businessService : "BPA";
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  return bpaBusinessService == "BPA" ? props?.t("BPA_PERMIT_APPLICATION_NUMBER_LABEL") : props?.t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL")
}

const BannerPicker = (props) => {
  return (
    <Banner
      message={GetActionMessage(props)}
      applicationNumber={props.data?.PermissionOfSubdivision[0].applicationNo}
      info={props.isSuccess ? getApplicationNoLabel(props) : ""}
      successful={props.isSuccess}
      headerStyles={{fontSize: "32px"}}
    />
  );
};

const OBPSAcknowledgement = ({ data, onSuccess }) => {
  const { t } = useTranslation();
  //const isPropertyMutation = window.location.href.includes("property-mutation");
  const tenantId = data?.landAreaDetails?.tenantId || Digit.ULBService.getCurrentTenantId();
  // const mutation = Digit.Hooks.obps.useObpsAPI(
  //   tenantId,
  //   true
  // ); 
  const mutation1 = Digit.Hooks.obps.useObpsAPI(
   tenantId,
    'Form11'
  );
  const { data: storeData } = Digit.Hooks.useStore.getInitData();
  const { tenants } = storeData || {};
  useEffect(() => {
    try {
      let tenantid = data?.address?.city ? data.address?.city?.code : tenantId;
      data.tenantId = tenantid;
      let formdata ={};
      // data?.nocDocuments?.NocDetails.map((noc) => {
      //   formdata = convertToNocObject(noc,data);
      //   mutation.mutate(formdata, {
      //       onSuccess,
      //     })
      // })
      formdata = convertForm11ToBPAObject(data);
      mutation1.mutate(formdata, {
        onSuccess,
      });
      
    } catch (err) {
      console.error(err);
    }
  }, []);

  return mutation1.isLoading || mutation1.isIdle ? (
    <Loader />
  ) : (
    <Card>
      <BannerPicker t={t} data={mutation1.data} isSuccess={mutation1.isSuccess} isLoading={mutation1.isIdle || mutation1.isLoading} />
      {mutation1.isSuccess && <CardText>{getCardText(t,mutation1.data)}</CardText>}
      {!mutation1.isSuccess && <CardText>{t("CS_FILE_PROPERTY_FAILED_RESPONSE")}</CardText>}
      <Link to={{
        pathname: `/digit-ui/citizen`,
      }}>
         <SubmitBar label={t("CORE_COMMON_GO_TO_HOME")} />
      </Link>
      {(mutation1.isSuccess && mutation1?.data?.PermissionOfSubdivision[0].businessService?.includes("UD")) && <Link to={{
            pathname: `/digit-ui/citizen/payment/collect/bpa/${mutation1.data.PermissionOfSubdivision[0].applicationNo}/${mutation1.data.PermissionOfSubdivision[0].tenantId}?tenantId=${mutation1.data.PermissionOfSubdivision[0].tenantId}?flow=${mutation1.data.PermissionOfSubdivision[0].applicationType}`,
            state: { tenantId: mutation1.data.PermissionOfSubdivision[0].tenantId },
          }}>
            <SubmitBar label={t("COMMON_MAKE_PAYMENT")} style={{transform: 'translate(15rem, -2.5rem)'}}/>
          </Link>}
      
    </Card>
  );
};

export default OBPSAcknowledgement;
